import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    page: {
        data: [],
        paginate: {
            pageNumber: 0,
            startIndex: -1,
            endIndex: 0,
            rowsPerPage: 0,
            totalRecords: 0,
        },
    },
    sortColumn: ["name", true],
    selectedBucket: null,
    bucketsDetail: [],
    availableLocations: [],
    accessibleBuckets: [],
    linkedLocations: [],
    bucketNoData: "",
    users: [],
    assignedUsers: [],
    isUsersLoading: false,
};

export const bucketsSlice = createSlice({
    name: "buckets",
    initialState,
    reducers: {
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setPageToNull: state => {
            state.page = {
                data: [],
                paginate: {
                    pageNumber: 0,
                    startIndex: -1,
                    endIndex: 0,
                    rowsPerPage: 0,
                    totalRecords: 0,
                },
            };
        },
        setSortColumn: (state, action) => {
            state.sortColumn = action.payload;
        },
        setSelectedBucket: (state, action) => {
            state.selectedBucket = action.payload;
        },
        setBucketsDetail: (state, action) => {
            state.bucketsDetail = action.payload;
        },
        setAccessibleBuckets: (state, action) => {
            state.accessibleBuckets = action.payload;
        },
        setAvailableLocations: (state, action) => {
            state.availableLocations = action.payload;
        },
        setLinkedLocations: (state, action) => {
            state.linkedLocations = action.payload;
        },
        setBucketNoData: (state, action) => {
            state.bucketNoData = action.payload;
        },
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        setAssignedUsers: (state, action) => {
            state.assignedUsers = action.payload;
        },
        setIsUsersLoading: (state, action) => {
            state.isUsersLoading = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setPage,
    setPageToNull,
    setSortColumn,
    setSelectedBucket,
    setBucketsDetail,
    setAvailableLocations,
    setAccessibleBuckets,
    setLinkedLocations,
    setBucketNoData,
    setUsers,
    setAssignedUsers,
    setIsUsersLoading,
} = bucketsSlice.actions;

export default bucketsSlice.reducer;
